export default __webpack_public_path__ + "static/media/regular_van.a90e1d23.svg";